/**
 * Recorte do artigo: esconde no editor o que não será avaliado
 * (IA, busca acadêmica, plágio, Spotify, Pomodoro, gamificação, dock).
 * Volte a `false` quando quiser a barra completa de novo.
 */
export const THESIS_CLEAN_CHROME = true;

/** Compartilhar documento (botão/modal). `false` = oculto na UI. */
export const SHARE_UI_ENABLED = false;
